
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import ProfileCardV2 from "~/components/v2/profile-card/profile-card.vue";

import { mdiArrowLeft, mdiArrowRight } from "@mdi/js";

export default {
  components: { VueSlickCarousel, ProfileCardV2 },
  props: {
    profiles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      mdiArrowLeft,
      mdiArrowRight,
    };
  },
  computed: {
    vueSlickSettings() {
      if (this.$device && this.$device.isMobile) {
        return {
          dots: false,
          slidesToShow: 1.3,
          slidesToScroll: 1,
          arrows: false,
          swipe: true,
          swipeToSlide: true,
          infinite: false,
          lazyLoad: "progressive",
          draggable: true,
        };
      }
      // desktop
      return {
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        touchThreshold: 5,
        variableWidth: false,
        arrows: true,
        lazyLoad: "progressive",
        draggable: true,

        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.3,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
              swipe: true,
              swipeToSlide: true,
              infinite: false,
            },
          },
        ],
      };
    },
  },
};
